import { create } from "zustand";
import { persist } from "zustand/middleware";

interface EditorPrefsState {
	/**
	 * 長い行をペイン幅で折り返すか。整形済みのコードでは折り返さない方が読みやすく、ログや
	 * JSONL・Markdown 本文では折り返した方が読みやすいため、ファイルごとではなく利用者の
	 * 現在の作業内容に紐づく設定として持つ (開いている全タブに同時に効く)。
	 */
	wordWrap: boolean;
	toggleWordWrap: () => void;
}

export const useEditorPrefsStore = create<EditorPrefsState>()(
	persist(
		(set) => ({
			wordWrap: false,
			toggleWordWrap: () => set((state) => ({ wordWrap: !state.wordWrap })),
		}),
		{
			name: "izanagi-editor-prefs",
			partialize: (state) => ({ wordWrap: state.wordWrap }),
		},
	),
);
